import {Area, Cell, Event, Row  } from './links.model'


export default class LinksService {

    fetchareas(): Promise<Area[]> {
        return fetch('api/area/areas')
            .then(response => response.json() as Promise<Area[]>);
    }

    fetchEvents(): Promise<Event[]> {
        return fetch('api/config/event')
            .then(response => response.json() as Promise<Event[]>);
    }

    fetchcells(): Promise<Cell[]> {
        return fetch('api/cell/cells')
            .then(response => response.json() as Promise<Cell[]>);
    }


    fetchLinks(): Promise<Row[]> {
        return fetch('api/links/links')
            .then(response => response.json() as Promise<Row[]>);
    }

    /**
     * Posts an link to the server
     * @param link
     */
    postLink(link: Row): Promise<any> {
        return fetch('api/links/addlink',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(link)
            })
            .then(response => response.status);
    }


    /**
     * Deletes the links on the server
     * @param links
     */
    deleteLinks(links: Row[]): Promise<any> {
        return fetch('api/links/deletelink',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(links)
            })
            .then(response => response.status);
    }
}